import { ESubscribeStep } from './types';

export const STEPS_TOTAL = 2;

export const STEPS: ESubscribeStep[] = [
	ESubscribeStep.SubscriptionInfo,
	ESubscribeStep.Summary,
];
